var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTax(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 15.889,
    viewBox: "0 0 16 15.889",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_8437",
    "data-name": "Path 8437",
    d: "M1.008-7.847A3.354,3.354,0,0,0,4.35-4.439,3.372,3.372,0,0,0,7.713-7.847a3.391,3.391,0,0,0-3.364-3.43A3.373,3.373,0,0,0,1.008-7.847Zm1.261,0a2.112,2.112,0,0,1,2.08-2.169,2.117,2.117,0,0,1,2.1,2.169A2.111,2.111,0,0,1,4.35-5.7,2.107,2.107,0,0,1,2.269-7.847ZM10.3,1.071a3.354,3.354,0,0,0,3.342,3.408,3.372,3.372,0,0,0,3.364-3.408,3.391,3.391,0,0,0-3.364-3.43A3.373,3.373,0,0,0,10.3,1.071Zm1.261,0a2.093,2.093,0,1,1,4.183,0,2.092,2.092,0,1,1-4.183,0ZM14-11.344,3,3.793l1.018.752,11-15.137Z",
    transform: "translate(-1.008 11.344)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTax);
export default __webpack_public_path__ + "static/media/tax.8fca14373a7467c7bf0ba88c9317f67f.svg";
export { ForwardRef as ReactComponent };